import { getFirestore, doc, collection } from "firebase/firestore";


export default function useCodeGenerator(): {
  generateCode: (length: number) => string;
  generateInternalId: () => string;
  } {
  const generateCode = (length: number): string => {
    const charsetLetter = "ABCDHPRVWYZ";
    const charsetNumber = "2345789";
    let retVal = "";
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < length; i++) {
      let charset = charsetLetter;
      if (i > 2) {
        charset = charsetNumber;
      }

      const n = charset.length;
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  };

  const generateInternalId = (): string => doc(collection(getFirestore(), "idgen")).id;
  return { generateCode, generateInternalId };
}
